import React from "react";
import styled from "styled-components";

const StyledTextCenter = styled.div`
  text-align: ${({ align }) => align || 'center'};
`;

const TextAlign = ({ children, align }) => {
  return (
    <>
      <StyledTextCenter align={align}>{children}</StyledTextCenter>
    </>
  );
};

export default TextAlign;
